import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from './CategoryLandingPage.module.scss';
import { isFormattedText, isProductList, isSlider, isSubcategories } from './typeGuards';
import { ProductsResponse, CategoryLandingPage as CategoryLandingPageI,
  CategoryLandingPageSection, CategoryWithThumbnail } from '@services';
import { FormattedText, ProductList, Slider, Subcategories } from './sections';

const CN = 'category-landing-page';
const cx = classNames.bind(styles);

interface Props {
  content: CategoryLandingPageI;
  productLists: Record<string, ProductsResponse> | null;
  subcategories: CategoryWithThumbnail[] | null
}

export const CategoryLandingPage: React.FC<Props> = ({
  content: {
    sections
  },
  productLists,
  subcategories
}) => {

  const renderSection = (section: CategoryLandingPageSection, index: number): ReactElement | null => {
    if (isFormattedText(section)) {
      return <FormattedText section={ section }/>;
    } else if (isProductList(section) && productLists?.[section.product_list.title]) {
      return (
        <ProductList
          key={ index }
          section={ section }
          products={ productLists?.[section.product_list.title] }
        />
      );
    } else if (isSlider(section)) {
      return <Slider section={ section } />;
    } else if (isSubcategories(section) && subcategories?.length) {
      return (
        <Subcategories
          section={ section }
          subcategories={ subcategories }
        />
      );
    }

    return null;
  };

  return (
    <div className={ cx(CN) }>
      {sections.map(renderSection)}
    </div>
  );
};
